import { config } from "@/shared/lib/config";
import { handleError } from "@/shared/lib/fetcher";

export type BackupStatus = {
  due: boolean;
  intervalDays: number;
  lastDownloadAt: string | null;
  lastDownloadByName: string | null;
  nextDueAt: string | null;
  daysOverdue: number;
  messageLo: string;
};

export const backupsApi = {
  async getStatus(): Promise<BackupStatus> {
    const res = await fetch(`${config.apiUrl}/backups/status`, {
      credentials: "include",
    });
    if (!res.ok) await handleError(res);
    return res.json();
  },

  async downloadDatabase(): Promise<void> {
    const res = await fetch(`${config.apiUrl}/backups/database/download`, {
      method: "POST",
      credentials: "include",
    });
    if (!res.ok) await handleError(res);

    const blob = await res.blob();
    const disposition = res.headers.get("Content-Disposition") ?? "";
    const match = /filename="([^"]+)"/.exec(disposition);
    const fileName =
      match?.[1] ??
      `mineral-db-backup-${new Date().toISOString().slice(0, 10)}.sql.gz`;

    const url = URL.createObjectURL(blob);
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = fileName;
    anchor.click();
    URL.revokeObjectURL(url);
  },
};
